<template>
    <gd-modal name="add-leaderboard-team-modal" :title="$t('frontend_groovesell_add_leaderboard_team')" height="80%"
        width="80%" :no-overflow="true" v-if="leaderboard" allowOverflow class="gs-leaderboard-team-editor">
        <div class="flex flex-col m-6 mb-4">
            <div class="flex flex-col w-full mr-2 mb-2">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_team_name') }}</label>
                <text-input v-model="leaderBoardTeamModal.name" :attribute="$t('frontend_name')"
                    :value="leaderBoardTeamModal.name" :placeholder="$t('frontend_name')" />
            </div>
        </div>

        <div class="px-4">
            <div class="flex pt-2 pr-2">
                <div class="w-1/2 flex flex-row pl-2" v-if="leaderboard.funnel_id">
                    <affiliates-auto-suggest :funnel="leaderboard.funnel_id" :excluded="selectedAffiliateIdArr"
                        :button="$t('frontend_groovesell_button_add_affiliate')" class="gs-leaderboard-team-editor__affiliate-chooser"
                        @onAffiliateAdded="addedAffiliate_add_team" />
                </div>
            </div>

            <div class="flex mt-2 pt-2 pr-2">
                <div class="w-full flex flex-row" v-if="leaderboard.funnel_id">
                    <affiliate-list-view :funnel="leaderboard.funnel_id"
                        :affiliate-ids="suggestionSelectedAffiliates_add_team"
                        @onAffiliateRemoved="removedAffiliate_add_team" />
                </div>
            </div>
        </div>

        <div class="flex flex-row justify-end mr-4 mt-4 mb-4">
            <gd-button v-if="suggestionSelectedAffiliates_add_team &&
                suggestionSelectedAffiliates_add_team.length > 0 &&
                !validation.leaderBoardTeamModal.name.$error" variant="primary" size="auto" class="mr-4 mb-4 gs-leaderboard-team-editor__submit"
                @click="addEditLeaderBoardTeam">{{
                    $t('frontend_create_team') }}</gd-button>
            <gd-button v-else disabled size="auto" class="mr-4 mb-4">{{ $t('frontend_create_team') }}</gd-button>
        </div>
    </gd-modal>
</template>
<script>
import AffiliatesAutoSuggest from '@/components/AffiliatesAutoSuggest';
import AffiliateListView from '@/components/AffiliateListView';

export default {
    components: {
        AffiliatesAutoSuggest,
        AffiliateListView
    },
    props: {
        leaderboard: {
            required: true
        },
        leaderBoardTeamModal: {
            required: true
        },
        selectedAffiliateIdArr: {
            required: true
        },
        addedAffiliate_add_team: {
            required: true
        },
        suggestionSelectedAffiliates_add_team: {
            required: true
        },
        removedAffiliate_add_team: {
            required: true
        },
        addEditLeaderBoardTeam: {
            required: true
        },
        validation: {
            required: true
        },
    }
}
</script>
<style scoped>
.gs-leaderboard-team-editor ::v-deep(.gd-modal__content) {
    padding: 0.75rem;
}

.gs-leaderboard-team-editor ::v-deep(.gd-modal__content > div) {
    width: min(680px, calc(100vw - 1.5rem)) !important;
    max-width: calc(100vw - 1.5rem) !important;
    height: auto !important;
    max-height: calc(100vh - 1.5rem);
    overflow-y: auto;
}

.gs-leaderboard-team-editor ::v-deep(.gd-modal__content > div > div:first-child) {
    min-height: 4rem;
    height: auto;
    padding: 0.875rem 1rem;
}

.gs-leaderboard-team-editor ::v-deep(.gd-modal__content > div > div:first-child > span:first-child) {
    min-width: 0;
    overflow-wrap: anywhere;
}

.gs-leaderboard-team-editor ::v-deep(.h-10),
.gs-leaderboard-team-editor ::v-deep(button) {
    min-height: 44px;
}

.gs-leaderboard-team-editor ::v-deep(input),
.gs-leaderboard-team-editor ::v-deep(.VueTables__search__input) {
    min-height: 44px;
    height: 44px;
}

.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser > button:not(:disabled)) {
    color: var(--gs-primary) !important;
    background: transparent !important;
    border-color: var(--gs-primary) !important;
}

.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .autosuggest__results),
.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .autosuggest__results ul) {
    color: var(--gs-foreground) !important;
    background: var(--gs-surface) !important;
    border-color: var(--gs-border) !important;
}

.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .autosuggest__results-item) {
    min-height: 44px;
    color: var(--gs-foreground) !important;
    background: var(--gs-surface) !important;
    border-color: var(--gs-border) !important;
}

.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .autosuggest__results-item:hover),
.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .autosuggest__results-item:active),
.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .autosuggest__results-item:focus),
.gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .autosuggest__results-item.autosuggest__results-item--highlighted) {
    color: var(--gs-foreground) !important;
    background: var(--gs-primary-soft) !important;
    border-color: var(--gs-primary) !important;
}

.gs-leaderboard-team-editor ::v-deep(#affiliates-data-list-view button) {
    width: 44px;
    min-width: 44px;
    height: 44px;
    min-height: 44px;
    color: var(--gs-danger) !important;
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
}

.gs-leaderboard-team-editor__submit {
    color: var(--gs-primary-foreground) !important;
    background: var(--gs-primary) !important;
    border-color: var(--gs-primary) !important;
}

.gs-leaderboard-team-editor ::v-deep(button:focus-visible),
.gs-leaderboard-team-editor ::v-deep(input:focus-visible) {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
    box-shadow: var(--gs-active-shadow) !important;
}

@media (max-width: 640px) {
    .gs-leaderboard-team-editor ::v-deep(.m-6) {
        margin: 1rem;
    }

    .gs-leaderboard-team-editor ::v-deep(.w-1\/2) {
        width: 100%;
    }

    .gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser) {
        flex-direction: column;
        gap: 0.75rem;
        min-width: 0;
    }

    .gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser .vue-autosuggest),
    .gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser #autosuggest) {
        width: 100%;
        min-width: 0;
    }

    .gs-leaderboard-team-editor ::v-deep(.gs-leaderboard-team-editor__affiliate-chooser > button) {
        width: 100%;
        margin-left: 0 !important;
    }

    .gs-leaderboard-team-editor ::v-deep(.px-4) {
        padding-right: 1rem;
        padding-left: 1rem;
    }
}
</style>
